import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
import axios from '../axios';
import lodash from "lodash";

const ACTIONS_SEARCH = {
    GET_PLAYER_REQUEST: 'player',
    GET_PLAYER_SUCCESS: 'GET_PLAYER_SUCCESS',
    GET_PLAYER_ERROR: 'GET_PLAYER_ERROR',
    GET_OPPONENT_PLAYER_REQUEST: 'opp_player',
    GET_OPPONENT_PLAYER_SUCCESS: 'GET_OPPONENT_PLAYER_SUCCESS',
    GET_OPPONENT_PLAYER_ERROR: 'GET_OPPONENT_PLAYER_ERROR',
    GET_INFO_PLAYER_SUCCESS: 'GET_INFO_PLAYER_SUCCESS',
    GET_INFO_PLAYER_ERROR: 'GET_INFO_PLAYER_ERROR',    
    GET_INFO_PLAYER_PITCHER_BALL_TYPE_PERFORMANCES_SUCCESS: 'GET_INFO_PLAYER_PITCHER_BALL_TYPE_PERFORMANCES_SUCCESS',
    GET_INFO_PLAYER_PITCHER_BALL_TYPE_PERFORMANCES_ERROR: 'GET_INFO_PLAYER_PITCHER_BALL_TYPE_PERFORMANCES_ERROR',
    GET_INFO_PLAYER_PITCHER_ORDINARY_HITS_SUMMARIES_SUCCESS: 'GET_INFO_PLAYER_PITCHER_ORDINARY_HITS_SUMMARIES_SUCCESS',
    GET_INFO_PLAYER_PITCHER_ORDINARY_HITS_SUMMARIES_ERROR: 'GET_INFO_PLAYER_PITCHER_ORDINARY_HITS_SUMMARIES_ERROR',
    GET_INFO_PLAYER_BATTER_HOTZONE_SUCCESS: 'GET_INFO_PLAYER_BATTER_HOTZONE_SUCCESS',
    GET_INFO_PLAYER_BATTER_HOTZONE_ERROR: 'GET_INFO_PLAYER_BATTER_HOTZONE_ERROR',
    GET_INFO_PLAYER_BATTER_BATTED_BALL_DIRECTION_SUCCESS: 'GET_INFO_PLAYER_BATTER_BATTED_BALL_DIRECTION_SUCCESS',
    GET_INFO_PLAYER_BATTER_BATTED_BALL_DIRECTION_ERROR: 'GET_INFO_PLAYER_BATTER_BATTED_BALL_DIRECTION_ERROR'
};


const updateStatus = (type, data) => ({
    type,
    data,
});

const getSearchCommon = (text, type) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/masters/players?keyword=${text}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                if (type === ACTIONS_SEARCH.GET_PLAYER_REQUEST) {
                    dispatch(updateStatus(ACTIONS_SEARCH.GET_PLAYER_SUCCESS, data))
                }else {
                    dispatch(updateStatus(ACTIONS_SEARCH.GET_OPPONENT_PLAYER_SUCCESS, data))
                }
            },
            (err) => {
                if (type === ACTIONS_SEARCH.GET_PLAYER_REQUEST) {
                    dispatch(updateStatus(ACTIONS_SEARCH.GET_PLAYER_ERROR, err))
                }else {
                    dispatch(updateStatus(ACTIONS_SEARCH.GET_OPPONENT_PLAYER_ERROR, err))
                }

            });
    };
};
const getPlayers = (keyword) => {
    return async () => {
        const {data} = await axios.get('/api/masters/players', {
            params: {
                keyword,
            },
        });

        return lodash.uniqBy(data, function (e) {
            return e.id;
        });
    };
};
const getInfoPlayer = (player_id) => {
    return async (dispatch) => {
        try {
            const { data } = await axios.get(`api/players/${player_id}`);
            if (data.position_type_name === '投手') {
                const playerInfo = await axios.get(`api/players/${player_id}/basic/pitcher`);
                data.playerInfo = playerInfo.data;
            } else {
                const playerInfo = await axios.get(`api/players/${player_id}/basic/batter`);
                data.playerInfo = playerInfo.data;
            }
            dispatch(updateStatus(ACTIONS_SEARCH.GET_INFO_PLAYER_SUCCESS, data));
        } catch (error) {
            dispatch(updateStatus(ACTIONS_SEARCH.GET_INFO_PLAYER_ERROR, error));
        }
    };
};

const getPlayerPitcherBallTypePerformances = (player_id, year_id) => {
    return async (dispatch) => {
        try {
            const { data } = await axios.get(`api/players/${player_id}/basic/pitcher/ball_type_performances?year_id=${year_id}`);
            dispatch(updateStatus(ACTIONS_SEARCH.GET_INFO_PLAYER_PITCHER_BALL_TYPE_PERFORMANCES_SUCCESS, data));
        } catch (error) {
            dispatch(updateStatus(ACTIONS_SEARCH.GET_INFO_PLAYER_PITCHER_BALL_TYPE_PERFORMANCES_ERROR, error));
        }
    };
};

const getPlayerPitcherOrdinaryHitsSummaries = (player_id, year_id) => {
    return async (dispatch) => {
        try {
            const { data } = await axios.get(`api/players/${player_id}/basic/pitcher/ordinary_hits_summaries?year_id=${year_id}`);
            dispatch(updateStatus(ACTIONS_SEARCH.GET_INFO_PLAYER_PITCHER_ORDINARY_HITS_SUMMARIES_SUCCESS, data));
        } catch (error) {
            dispatch(updateStatus(ACTIONS_SEARCH.GET_INFO_PLAYER_PITCHER_ORDINARY_HITS_SUMMARIES_ERROR, error));
        }
    };
};

const getPlayerBatterHotzone = (player_id, year_id) => {
    return async (dispatch) => {
        try {
            const { data } = await axios.get(`api/players/${player_id}/basic/batter/hotzone?year_id=${year_id}`);
            dispatch(updateStatus(ACTIONS_SEARCH.GET_INFO_PLAYER_BATTER_HOTZONE_SUCCESS, data));
        } catch (error) {
            console.info('error getPlayerBatterHotzone', player_id, year_id)
            dispatch(updateStatus(ACTIONS_SEARCH.GET_INFO_PLAYER_BATTER_HOTZONE_ERROR, error));
        }
    };
};

const getPlayerBatterBattedBallDirection = (player_id, year_id) => {
    return async (dispatch) => {
        try {
            const { data } = await axios.get(`api/players/${player_id}/basic/batter/batted_ball_direction?year_id=${year_id}`);
            dispatch(updateStatus(ACTIONS_SEARCH.GET_INFO_PLAYER_BATTER_BATTED_BALL_DIRECTION_SUCCESS, data));
        } catch (error) {
            dispatch(updateStatus(ACTIONS_SEARCH.GET_INFO_PLAYER_BATTER_BATTED_BALL_DIRECTION_ERROR, error));
        }
    };
};

export {
    ACTIONS_SEARCH, getSearchCommon, getInfoPlayer, getPlayers,
    getPlayerPitcherBallTypePerformances,
    getPlayerPitcherOrdinaryHitsSummaries,
    getPlayerBatterHotzone,
    getPlayerBatterBattedBallDirection
};
